import { defaultCurrency } from "@/lib/currency";
import { Currency } from "@/types/currency";
import { formatCurrency, formatNumber } from "@/utils/formatEuro";

import type { CarChartValueType } from "./types";

export function formatValueFromType(valueType: CarChartValueType, currency: Currency) {
  return (value: number) => {
    if (valueType === "percent") {
      // Percentage
      return formatNumber(value, {
        style: "percent",
        maximumFractionDigits: 1,
        roundingMode: "halfEven",
      });
    }

    return formatCurrency(value, currency.code || defaultCurrency.code); // fallback
  };
}

export function getValueFromType(valueType: CarChartValueType, total = 0) {
  return (value: number) => {
    if (valueType === "percent") {
      if (total === 0) return 0; // Avoid division by zero
      return value / total;
    }
    return value;
  };
}
